import step1InitialMessage from './tutorialAssets/sequence/step-1-initial-message.png'
import step2SaveStep from './tutorialAssets/sequence/step-2-save-step.png'
import step3WaitDays from './tutorialAssets/sequence/step-3-wait-days.png'
import step4StartCampaign from './tutorialAssets/sequence/step-4-start-campaign.png'

export const dripMessageSequenceTutorialTitle = 'How to set up a message sequence'

export const dripMessageSequenceTutorialSteps = [
  {
    title: 'Open the Sequence tab and edit the Initial Message',
    description:
      'After enabling message sequence, go to the Sequence tab. Click Initial Message to set up the first text or email guests will receive.',
    imageSrc: step1InitialMessage,
    imageAlt: 'Sequence tab with Initial Message highlighted'
  },
  {
    title: 'Configure the step and save',
    description:
      'Write or review the message content for this step, then click Save Step so your changes are stored before you continue.',
    imageSrc: step2SaveStep,
    imageAlt: 'Step configuration with Save Step highlighted'
  },
  {
    title: 'Set how long to wait before the next message',
    description:
      'Choose how many days to wait before sending the next message in the sequence. This delay runs after the previous step is sent.',
    imageSrc: step3WaitDays,
    imageAlt: 'Wait before sending the next message setting highlighted'
  },
  {
    title: 'Go to Promotion and start the campaign',
    description:
      'When your sequence steps look good, open the Promotion tab and click Start campaign to begin sending to guests.',
    imageSrc: step4StartCampaign,
    imageAlt: 'Promotion tab with the Start campaign button highlighted'
  }
]
